module.exports = {
      id: "clipboard-usage",
      viewBox: "0 0 44 44",
      url: "/" + "sprite-8d2e5ebc566e02833b7f09cd596911c9.svg#clipboard",
      toString: function () {
        return this.url;
      }
    }